// 此处后续替换为修改过样式
import Vue from 'vue'
import App from './App'
import router from './router'
import ajax from '@/services/ajax'
import request from '@/services/request'
import INTERFACE from './interface'
import FastClick from 'fastclick'
import './style/all.styl'
import { Button } from 'mint-ui'
import './assets/common/css/pages.css'
import config from './config'
// 注册全局组件标签
Vue.component(Button.name, Button);

// mock 启动
require('@/mock')
// if (/192\.168\.2\.27/.test(location.href)) {
//   require('@/mock');
// }
// 全局变量http://pmh.gc-life.com/
window.localStorage.permissionCheckUrl = 'platform/v1/access/resources'
window.localStorage.defaultLanguage = 'EN_US'

// 动态设置环境
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/'
  window.localStorage.serviceName = 'https://dev-bmp-apply.zjlh.lan'
  window.localStorage.loginUrl = 'https://dev-bmp.zjlh.lan'
  window.localStorage.dashboardUrl = 'https://dev-bmp.zjlh.lan/#/dashboard'
  window.localStorage.cookieDomain = '.zjlh.lan'
} else if (process.env.NODE_ENV === 'stag') {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/'
  window.localStorage.serviceName = 'https://stag-bmp-apply.gc-life.cn'
  window.localStorage.loginUrl = 'https://stag-bmp.gc-life.cn'
  window.localStorage.dashboardUrl = 'https://stag-bmp.gc-life.cn/#/dashboard'
  window.localStorage.cookieDomain = '.gc-life.cn'
} else if (process.env.NODE_ENV === 'production') {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/'
  window.localStorage.serviceName = 'https://bmp-apply.gc-life.com'
  window.localStorage.loginUrl = 'https://bmp.gc-life.com/#/'
  window.localStorage.dashboardUrl = 'https://bmp.gc-life.com/#/dashboard'
  window.localStorage.cookieDomain = '.gc-life.com'
}
console.log(window.localStorage.gatewayDomain)

// 插件配置
Vue.config.productionTip = false;
// 清除点击事件300ms延迟
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body);
  }, false);
}
// 配置初始化
// config.init()
// axios 统一配置
ajax.init()

// 设置请求头
request.init()

// 此处调用国际化接口，获取国际化数据
var language = config.getCookie('language')
if (!language || !language.length) {
  language = window.localStorage.defaultLanguage
}
// 此处调用国际化接口，获取国际化数据
// INTERFACE.getI18nType().then((data) => {
INTERFACE.getI18n(language).then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })
})
// })



// WEBPACK FOOTER //
// ./src/main.js